import React from 'react'

const UpdateProccessPopupContext = React.createContext()

export default UpdateProccessPopupContext